import { client } from "./src/services/client";

client.interceptors.request.use((request, options) => {
  if (options.parseAs !== "blob") {
    options.parseAs = "json";
  }

  return request;
});

export * from "./src/services/client/@tanstack/react-query.gen";
export * from "./src/services/client";
